import React, { useContext, useState } from 'react'
import ReactModal from 'react-modal'
import WhiteLabelEditModal from '../../shared/WhiteLabelEditModal'
import { useQuery } from '@apollo/client'
import { GET_WHITE_LABELING_BY_ID } from '../../graphql/query'
import { usePlan } from '../../context/PlanContext'

const WhiteLabelComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const { currentPlan } = usePlan()

  const { data, loading, error } = useQuery(GET_WHITE_LABELING_BY_ID, {
    variables: {
      input: {
        bgAccountId: currentPlan?.bgAccountId
      }
    }
  })
  console.log(currentPlan)
  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const afterOpenModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  if (loading) {
    return <p>Loading...</p>
  }

  if (error) {
    console.error(error)
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bold m-0'>White Label</h3>
        </div>
        <div className='card-footer d-flex justify-content-end py-6 px-1'>
          {currentPlan?.package?.feature?.whiteLabelRemoveBranding === true && (
            <>
              <div className='ms-auto' title='Edit your business details'>
                <div onClick={openModal} className='btn btn-light btn-active-light-primary'>
                  Edit
                </div>
                <ReactModal
                  isOpen={isModalOpen}
                  onAfterOpen={afterOpenModal}
                  onRequestClose={closeModal}
                  style={customModalStyles}
                  contentLabel='Edit Business Details'
                >
                  <WhiteLabelEditModal
                    closeModal={closeModal}
                    data={data}
                    currentPlan={currentPlan}
                  />
                </ReactModal>
              </div>
            </>
          )}
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>
          {/* Company Name Input */}
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
              Company Name
            </label>

            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                value={
                  data?.getWhiteLabelingbyId[0]?.companyName ||
                  'Botgo Technologies Pvt Ltd. (by Globtier)'
                }
                placeholder='Enter your company name'
              />
            </div>
          </div>

          {/* Copyright Input */}
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
              Copyright Link
            </label>
            <div className='col-lg-8 fv-row'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                value={data?.getWhiteLabelingbyId[0]?.copyright || 'https://globtierinfotech.com/'}
                placeholder='Enter copyright text'
              />
            </div>
          </div>

          {/* Logo Upload */}
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-semibold fs-6'>Logo</label>
            <div className='col-lg-8 fv-row'>
              <img
                className='w-25 h-100 shadow'
                src={data?.getWhiteLabelingbyId[0]?.logo || '/media/logos/botgo-logo-2nd.png'}
                alt='logo'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WhiteLabelComponent
